import React, { useState, useEffect } from "react";
import { uploadUserDocument } from "../../../../ApiService/ApiService";
import {
  Box,
  Paper,
  IconButton,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { ArrowBack, Create, Update } from "@mui/icons-material";
import CustomDialog from "../../../../Components/CustomDialog";

function UpdateDocuments({
  setActionComponent,
  selectedStudentId,
  studentDocuments,
  setStudentDocuments,
}) {
  const [files, setFiles] = useState([]);
  const [urlFromAPI, setUrlFromAPI] = useState("");
  const [dialog, setDialog] = useState({
    visible: false,
    title: "",
    message: "",
    buttons: [],
  });

  useEffect(() => {
    setFiles(Array(studentDocuments?.length).fill(null));
  }, [studentDocuments]);

  const handleFileButtonClick = (index) => {
    const fileInput = document.getElementById(`contained-button-file-${index}`);
    fileInput.click();
  };

  const handleFileChange = (event, index) => {
    const selectedFile = event.target.files[0];
    const updatedFiles = [...files];
    updatedFiles[index] = selectedFile;
    setFiles(updatedFiles);
  };

  const handleDialogClose = () => {
    setDialog({ ...dialog, visible: false });
  };

  const handleSubmit = async (index) => {
    console.log(studentDocuments);
    try {
      const file = files[index];
      if (!file) {
        setDialog({
          visible: true,
          title: "Error",
          message: "Please select a file",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
      if (file.size > 300 * 1024) {
        setDialog({
          visible: true,
          title: "Error",
          message: "File size must be less than 300KB.",
          buttons: [{ name: "Close", onPress: handleDialogClose }],
        });
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await uploadUserDocument(
        selectedStudentId,
        studentDocuments?.data[index].documentName,
        formData
      );
      // console.log("Upload response:", response?.data);
      // Update the document URL after successful upload
      const updatedDocuments = [...studentDocuments.data];
      updatedDocuments[index].documentUrl = response?.data?.data;
      setStudentDocuments({ ...studentDocuments, data: updatedDocuments });
      // console.log("UPDATE", studentDocuments?.data);
      setDialog({
        visible: true,
        title: "Success",
        message: "Image uploaded",
        buttons: [{ name: "OK", onPress: handleDialogClose }],
      });
      const updatedFiles = [...files];
      updatedFiles[index] = null;
      setFiles(updatedFiles);
    } catch (error) {
      setDialog({
        visible: true,
        title: "Error",
        message: "Something went wrong",
        buttons: [{ name: "Close", onPress: handleDialogClose }],
      });
    }
  };

  console.log("students", studentDocuments);

  return (
    <>
      <CustomDialog
        visible={dialog.visible}
        title={dialog.title}
        message={dialog.message}
        buttons={dialog.buttons}
        onClose={handleDialogClose}
      />
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 3,
            marginTop: 2,
            marginBottom: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: { xs: 600, sm: 600, md: 600, lg: "100%" },
            overflow: "auto",
          }}
        >
          {studentDocuments?.data?.length > 0 ? (
            <>
              <Grid container spacing={2}>
                {studentDocuments?.data?.map((singleDocument, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={4}
                    key={index}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Paper
                      elevation={3}
                      sx={{
                        padding: 2,
                        margin: 1,
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography variant="subtitle1">
                        <strong>{singleDocument?.documentName}</strong>
                      </Typography>
                      <Box
                        sx={{ position: "relative", display: "inline-block" }}
                      >
                        <img
                          src={
                            files[index]
                              ? URL.createObjectURL(files[index])
                              : singleDocument?.documentUrl
                          }
                          alt="Profile"
                          style={{
                            marginTop: "10px",
                            height: 150,
                            width: 150,
                            borderRadius: "50%",
                            border: "1px solid gray",
                          }}
                        />

                        <IconButton
                          size="small"
                          onClick={() => handleFileButtonClick(index)}
                          sx={{
                            fontSize: 12,
                            position: "absolute",
                            bottom: -10,
                            left: 60,
                            color: "white",
                            backgroundColor: "#2659c8",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "white",
                              border: "1px solid #2659c8",
                              color: "#2659c8",
                            },
                          }}
                        >
                          <Create />
                        </IconButton>
                      </Box>
                      <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id={`contained-button-file-${index}`}
                        type="file"
                        onChange={(event) => handleFileChange(event, index)}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleSubmit(index)}
                        disabled={!files[index]}
                        sx={{
                          textTransform: "unset",
                          marginTop: 2,
                          marginBottom: 1,
                          height: 40,
                        }}
                      >
                        Update{" "}
                        <Update fontSize="small" sx={{ marginLeft: 1 }} />
                      </Button>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Box>
              <Typography variant="body1">No documents available</Typography>
            </Box>
          )}
          <Button
            variant="contained"
            color="inherit"
            onClick={() => setActionComponent(null)}
            sx={{
              textTransform: "unset",
              marginTop: 2,
              display: studentDocuments?.data?.length === 0 ? "none" : "flex",
            }}
          >
            <ArrowBack fontSize="small" sx={{ marginRight: 1 }} />
            Back
          </Button>
        </Paper>
      </Box>
    </>
  );
}

export default UpdateDocuments;
